import React from "react";
import Guideline from "./Guideline";
function DropDownQuestion(props) {
  return (
    <li id={props.id + "_li"}>
      <label className="description" htmlFor={props.id}>
        {props.QuestionText}
      </label>
      <div>
        <select
          className={"element text currency " + props.Section}
          id={props.id}
          name={props.id}
          onChange={(event) => {
            props.handleValue(event);
          }}
          defaultValue={props.Answer}
        >
          {props.Choices.map((choiceText) => {
            return (
              <option key={choiceText} value={choiceText}>
                {choiceText}
              </option>
            );
          })}
        </select>
      </div>
      {props.GuidelineText ? (
        <Guideline id={props.id}> {props.GuidelineText}</Guideline>
      ) : (
        <></>
      )}
      {props.children}
    </li>
  );
}

export default DropDownQuestion;
